<template>
  <v-container>
    <v-card class="mb-6">
      <v-card-title class="d-flex justify-space-between align-center">
        <div>
          <v-icon left color="primary" class="mr-2">mdi-account</v-icon>
          <span class="primary--text">个人中心</span>
        </div>
        <div class="text-subtitle-1">
          欢迎你，{{ username }}
        </div>
      </v-card-title>
    </v-card>

    <v-card class="mb-6">
      <v-card-title class="primary--text">
        <v-icon left color="primary">mdi-lock</v-icon>
        账户安全
      </v-card-title>
      <v-card-text class="pa-6">
        <v-form @submit.prevent="changePassword">
          <v-row>
            <v-col cols="12">
              <v-text-field 
                v-model="password" 
                label="当前密码" 
                type="password" 
                outlined 
                required
                prepend-inner-icon="mdi-lock-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field 
                v-model="newPassword" 
                label="新密码" 
                type="password" 
                outlined 
                required
                prepend-inner-icon="mdi-lock-plus"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn 
                type="submit" 
                color="primary" 
                outlined
                elevation="2"
                :loading="loading"
              >
                <v-icon left>mdi-content-save</v-icon>
                保存修改
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mb-6">
      <v-card-title class="primary--text">
        <v-icon left color="primary">mdi-key-variant</v-icon>
        OAuth 2.1 Token
      </v-card-title>
      <v-card-text class="pa-6">
        <p class="mb-4">可以使用以下 Token 访问 MCP Server：</p>
        <v-text-field
          v-model="token"
          label="访问令牌"
          outlined
          readonly
          append-icon="mdi-content-copy"
          @click:append="copyToken"
          hide-details
          class="mb-4"
        ></v-text-field>
        <v-btn
          color="primary"
          outlined
          @click="copyToken"
          elevation="2"
        >
          <v-icon left>mdi-content-copy</v-icon>
          复制令牌
        </v-btn>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title class="error--text">
        <v-icon left color="error">mdi-logout</v-icon>
        退出登录
      </v-card-title>
      <v-card-text class="pa-6">
        <p class="mb-4">如果您需要退出当前账号，请点击下方按钮</p>
        <v-btn 
          color="error" 
          outlined 
          @click="logout"
          elevation="2"
        >
          <v-icon left>mdi-logout-variant</v-icon>
          退出登录
        </v-btn>
      </v-card-text>
    </v-card>
    
    <!-- 添加消息提示 -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">关闭</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      username: this.$store.state.username,
      password: '',
      newPassword: '',
      token: '',
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      loading: false
    }
  },
  mounted() {
    this.getToken();
  },
  methods: {
    getToken() {
      const token = localStorage.getItem('token');
      this.token = token || '未找到令牌';
    },
    copyToken() {
      if (this.token && this.token !== '未找到令牌') {
        navigator.clipboard.writeText(this.token)
          .then(() => {
            this.snackbarMessage = '令牌已复制到剪贴板';
            this.snackbarColor = 'success';
            this.snackbar = true;
          })
          .catch(err => {
            this.snackbarMessage = '复制失败: ' + err;
            this.snackbarColor = 'error';
            this.snackbar = true;
          });
      } else {
        this.snackbarMessage = '没有可用的令牌';
        this.snackbarColor = 'warning';
        this.snackbar = true;
      }
    },
    async changePassword() {
      this.loading = true;
      try {
        const params = new URLSearchParams();
        params.append('name', this.username);
        params.append('password', this.password);
        params.append('newPassword', this.newPassword);

        const response = await axios.post('https://qidafang.com/wikiapi/changePassword', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        if (response.data.code === 200) {
          this.snackbarMessage = '密码修改成功！';
          this.snackbarColor = 'success';
          this.password = '';
          this.newPassword = '';
        } else {
          this.snackbarMessage = '修改失败: ' + response.data.message;
          this.snackbarColor = 'error';
        }
      } catch (error) {
        this.snackbarMessage = '请求失败: ' + error.message;
        this.snackbarColor = 'error';
      } finally {
        this.snackbar = true;
        this.loading = false;
      }
    },
    logout() {
      this.$store.commit('logout');
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
/* 移除不需要的样式 */
</style>